import React from 'react';

function Buttons() {
  return (
    <div className="paper">
      <div className="styleguide__title">Buttons</div>
      <div className="styleguide__row">
        <label>Primary</label>
        <button className="button">Primary</button>
      </div>
      <div className="styleguide__row">
        <label>Large</label>
        <button className="button button--large">Large</button>
      </div>
      <div className="styleguide__row">
        <label>Secondary</label>
        <button className="button button--theme--secondary">Secondary</button>
      </div>
      <div className="styleguide__row">
        <label>Disabled</label>
        <button className="button button--disabled" disabled>
          Disabled
        </button>
      </div>
      <div className="styleguide__row">
        <label>Outline</label>
        <button className="button button--theme--outline">Outline</button>
      </div>
      <div className="styleguide__row">
        <label>Outline</label>
        <button className="button button--theme--white">Outline</button>
      </div>
      <div className="styleguide__row">
        <label>Plain</label>
        <button className="button button--theme--plain">Plain</button>
      </div>
      <div className="styleguide__row">
        <label>Full Width</label>
        <button className="button button--full-width">Primary</button>
      </div>
    </div>
  );
}

export default Buttons;



// WEBPACK FOOTER //
// ./src/style-guide/sections/Buttons.js